/**
 * DI-02 — the speaker notes card rendered in the chat thread.
 *
 * One card per slide that has notes, labelled "Slide N". Slides without notes
 * are left out. Notes are rendered as React text children, never as HTML, so
 * `<` and `&` show as literal characters (AC-3), and line breaks are kept with
 * white-space: pre-wrap (AC-4).
 */

import type { SpeakerNotesListResult } from "../types";
import styles from "./SpeakerNotesListCard.module.css";

export interface SpeakerNotesListCardProps {
  readonly result: SpeakerNotesListResult;
}

export function SpeakerNotesListCard({ result }: SpeakerNotesListCardProps) {
  return (
    <section className={styles.card} aria-label={result.header} data-outcome={result.outcome}>
      <h4 className={styles.heading}>{result.header}</h4>

      {result.items.length > 0 && (
        <ul className={styles.list}>
          {result.items.map((item) => (
            <li key={item.slideNumber} className={styles.row} data-testid={`notes-slide-${item.slideNumber}`}>
              <p className={styles.label}>Slide {item.slideNumber}</p>
              <p className={styles.text}>{item.text}</p>
            </li>
          ))}
        </ul>
      )}

      {result.footnote && <p className={styles.footnote}>{result.footnote}</p>}
    </section>
  );
}
